enum HaulagePricingMethod {
  PerLoad,
  PerMetricTonne,
  PerHour,
}

export const HaulagePricingMethodLabels = [
  'Per Load',
  'Per Ton',
  'Per Hour',
]

export default HaulagePricingMethod
